// extracted by mini-css-extract-plugin
module.exports = {"skeletonsContainer":"styles_skeletonsContainer__2xznr"};